<script setup lang="ts">
import { SolrParamsKey } from '#shared/solr'
import { faChevronRight } from '@fortawesome/pro-light-svg-icons'
import { CollapsibleContent, CollapsibleRoot, CollapsibleTrigger } from 'reka-ui'
import { useLawCommentaryQuery } from '~/composables/laws/useLawCommentaryQuery'
import { CALLOUT_VARIANT_STYLES } from '~/utils/callout'

const { objectId } = defineProps<{ objectId: number }>()

const { data } = useLawCommentaryQuery('law-commentary', computed(() => ({ [SolrParamsKey.InfoNoticeByEzObjectId]: objectId.toString() })))

const notice = computed(() => data.value?.response?.docs[0])

const isOpen = ref(false)

const { icon, color } = CALLOUT_VARIANT_STYLES.info
</script>

<template>
  <Callout v-if="notice?.title" variant="info" size="sm" hide-icon class="mb-xs">
    <CollapsibleRoot v-model:open="isOpen" class="w-full">
      <CollapsibleTrigger class="flex items-center gap-2xs w-full text-left font-bold text-carbon-500 cursor-pointer rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-blurple-500">
        <Icon :icon size="sm" :class="color" />
        <span class="flex-1">{{ notice.title }}</span>
        <Icon :icon="faChevronRight" size="sm" class="transition-transform duration-300" :class="{ 'rotate-90': isOpen }" />
      </CollapsibleTrigger>
      <CollapsibleContent class="pl-m">
        <div v-if="notice.bodytext" class="pt-2xs" v-html="notice.bodytext" />
      </CollapsibleContent>
    </CollapsibleRoot>
  </Callout>
</template>
